var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigmaLogoOutlineInverted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.321 9.757a2.273 2.273 0 1 0 0 4.546h2.335V9.757H9.321Zm5.715-1.106h.062a2.273 2.273 0 1 0 0-4.545h-2.336V8.65h2.274Zm1.915.553A3.38 3.38 0 0 0 15.098 3H9.32a3.38 3.38 0 0 0-1.853 6.204A3.375 3.375 0 0 0 5.94 12.03c0 1.182.607 2.222 1.527 2.826A3.375 3.375 0 0 0 5.94 17.68c0 1.87 1.533 3.38 3.395 3.38 1.88 0 3.426-1.523 3.426-3.41v-3.12a3.37 3.37 0 0 0 2.274.879h.062a3.38 3.38 0 0 0 1.853-6.205Zm-1.854.553h-.061a2.273 2.273 0 1 0 0 4.546h.062a2.273 2.273 0 1 0 0-4.546Zm-8.05 7.925a2.273 2.273 0 0 1 2.274-2.273h2.335v2.242a2.317 2.317 0 0 1-2.32 2.303 2.286 2.286 0 0 1-2.288-2.273Zm4.61-9.03H9.32a2.273 2.273 0 1 1 0-4.546h2.335V8.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaLogoOutlineInverted);
export default __webpack_public_path__ + "964a6da30aa4c94c803b25faa9810a9b.svg";
export { ForwardRef as ReactComponent };